import API from "Api";
import { generateDynamicEndpoint } from "utils/generalUtils";
import {
  CREATE_PHARMACY_ENDPOINT,
  DELETE_PHARMACY_ENDPOINT,
  GET_PHARMACIES_LIST_ENDPOINT,
  UPDATE_PHARMACY_ENDPOINT,
} from "./endpoints";

export const getPharmaciesListAPI = (payload) => {
  return API.post(GET_PHARMACIES_LIST_ENDPOINT, payload);
};

export const createPharmacyAPI = (payload) => {
  return API.post(CREATE_PHARMACY_ENDPOINT, payload);
};

export const updatePharmacyAPI = (id, payload) => {
  return API.put(
    generateDynamicEndpoint(UPDATE_PHARMACY_ENDPOINT, { pharmacy_id: id }),
    payload
  );
};

export const deletePharmacyAPI = (id) => {
  return API.deleteM(
    generateDynamicEndpoint(DELETE_PHARMACY_ENDPOINT, { pharmacy_id: id })
  );
};
